<template>
  <div class="main-container container-xxl">
    <titulo-grande texto="Cadastro de Categorias de Notícias" posicao="left" />

    <modal :tituloModal="textoBtnCadastro" @fecha_modal="fecha_modal" @hidden="fecha_modal"
      textoBtnChamada="Inserir Categoria" tamanho_modal="modal-md" @click_bt_modal="click_bt_modal" :exibe_botao="true">
      
      <template #default>
        <form @submit.prevent="cadastrar" enctype="multipart/form-data" id="cad_category">
          <fieldset>
            <InputText placeholder="" label="Nome da categoria *" tamanho="sm" nome="nome" ref="nome"
              v-model="nome" />

            <input type="submit" class="d-none" value="">
          </fieldset>
        </form>
      </template>
      <template #botaoPersonalizado>
        <fieldset>
          <button type="button" @click.prevent="cadastrar" class="btn btn-primary">Salvar
            <Spinner :visivel="false" id="loading" />
          </button>
        </fieldset>
      </template>
    </modal>

    <modal tituloModal="" @fecha_modal="fecha_modal" @hidden="fecha_modal"
      textoBtnChamada="" tamanho_modal="modal-md" :exibe_botao="false" id_modal="modal_delete">
      <template #default>
        Tem certeza que deseja deletar a categoria <strong>"{{ titulo_delete }}"</strong>?
      </template>
      <template #botaoPersonalizado>
        <fieldset>
          <button type="button" @click.prevent="deletar" class="btn btn-danger"><i class="bi bi-trash3-fill"></i> Deletar
            <Spinner :visivel="false" id="loading" />
          </button>
        </fieldset>
      </template>
    </modal>

    <TabelaDatatable :dadosData="dadosData" dadosAjax="" :btnStatus="true" :btnEdit="true" :btnDelete="true" :ativa_placeholder="ativa_placeholder"
      :columns="colunas" @edit_status="edit_status" @edit_row="dados_editar" @delete_row="deletar_dados" modal_target_delete="#modal_delete"></TabelaDatatable>
  </div>
</template>

<script>
import TabelaDatatable from '@/components/TabelaDatatable.vue';
import TituloGrande from '@/components/TituloGrande.vue'
import Modal from '@/components/Modal.vue';
import InputText from "@/components/form/InputText.vue";
import { toastr } from '@/plugins/toast.js'
import { AuthStore } from '@/stores/Auth';
import { api } from '@/services/api';

export default {
  components: { TituloGrande, TabelaDatatable, Modal, InputText },
  name: 'CadCategoriasNoticias',
  data() {
    return {
      auth: AuthStore(),
      id_delete: Number,
      titulo_delete: String,
      nome: '',
      dadosData: '',
      colunas: [
        { data: 'nome', title: 'Nome', width: '80%' },
        { name: 'acoes', data: 'status', title: 'Ações', width: '10%' },
      ],
      textoBtnCadastro: 'Cadastro de Categoria de Notícia',
      ativa_placeholder: Boolean,
    }
  },
  mounted() {
    this.listagemTabela();
  },
  methods: {
    async listagemTabela() {
      this.ativa_placeholder = true
      this.dadosData = await api.post('news_category/list')
      this.ativa_placeholder = false
    },
    async cadastrar(e) {
      e.preventDefault();

      if (!this.nome) {
        toastr.alerta("Digite o nome")
        return false;
      }

      const formu = document.querySelector("#cad_category")

      const dados = new FormData(formu)
      dados.append('link_amistoso', this.link_amistoso)
      if (this.img_data) {
        dados.append('imagem_destaque', this.img_data)
      }
      if (this.id_cat > 0) {
        dados.append('id', this.id_cat)
      }
      
      this.bloqueia_campos()
      try {
        const data = await api.post('news_category/register', dados, { Authorization: this.auth.token }, false)
        if (data?.status >= 400) {
          for (const key in data.message) {
            toastr.erro(data.message[key]);
          }
        } else if (data?.status == 200) {
          toastr.sucesso(data.message)
          if (!this.id_cat) {
            this.limpa_campos()
          }
          this.listagemTabela()
        } else {
          toastr.erro("Erro ao cadastrar a categoria, tente novamente dentro de alguns minutos.")
        }
      } catch (error) {
        toastr.erro("Erro ao cadastrar.");
      }
      this.bloqueia_campos(false)
    },
    bloqueia_campos(opt = true) {
      const campos = document.querySelector('fieldset')
      const loading = document.querySelector('#loading')
      if (opt) {
        loading.classList.remove('d-none');
        campos.setAttribute('disabled', 'disabled')
      } else {
        campos.removeAttribute('disabled')
        loading.classList.add('d-none');
      }
    },
    async edit_status(dados) {
      try {
        var sts = (dados.cellData == 'Ativo' ? 'Inativo' : 'Ativo')
        var id = dados.rowData.id
        var autoriza = await api.autoriza();

        const stat = {
          status: sts,
          id: id,
        }

        if (autoriza) {
          try {
            const data = await api.post('news_category/change_status', stat)
            if (data.status == 200) {
              var mgn = `Status de ${dados.rowData.nome} alterado para ${sts}`;
              if (sts == 'Ativo') {
                toastr.sucesso(mgn)
              } else {
                toastr.alerta(mgn)
              }
              this.listagemTabela()
            } else {
              toastr.erro('Erro ao alterar o status, tente novamente em alguns instantes.')
            }
          } catch (error) {
            toastr.erro('Erro ao se comunicar com a API, tente novamente em alguns instantes.')
          }
        } else {
          toastr.erro("É preciso estar logado como admin para esta ação.")
          this.$router.push('/login')
        }
      } catch (error) {
        toastr.erro("Erro na solicitação, tente novamente em alguns instantes.")
      }
    },
    async dados_editar(dados) {
      this.bloqueia_campos()
      var dadosEdit = await api.post('news_category/list/' + dados.rowData.id)
      
      this.id_cat = dados.rowData.id;
      this.nome = dadosEdit.nome;

      document.querySelector("#btn_modal_cadastrar").click()
      this.bloqueia_campos(false)
    },
    fecha_modal() {
      this.limpa_campos()
    },
    limpa_campos() {
      this.nome = '';
      this.id_cat = 0;
    },
    atribui_dados(dados) {
      this.nome = dados.nome;
    },
    click_bt_modal() {
      if (this.id_cat > 0) {
        this.textoBtnCadastro = 'Editando categoria: ' + this.nome
      } else {
        this.textoBtnCadastro = 'Cadastro de Categoria de Notícia'
      }
    },
    deletar_dados(dados){
      this.id_delete = dados.rowData.id
      this.titulo_delete = dados.rowData.nome
    },
    async deletar(){
      this.bloqueia_campos()
      var autoriza = await api.autoriza();

      if (autoriza) {
        try {
          var deletar = await api.post('news_category/delete/'+this.id_delete)
          if(deletar.status == 200){
            toastr.sucesso(deletar.message)
            this.listagemTabela()
            document.querySelector("#btn_close_modal_delete").click()
          }else{
            toastr.erro(deletar.message)
          }
        } catch (error) {
          toastr.erro(error)
        }
        this.bloqueia_campos(false)
      }
    }
  },
}
</script>

<style>

</style>